import thumbnail_karzoun from '../../assets/karzoun/thumbnail.png';

import image0 from '../karzoun/0.png';
import image1 from '../karzoun/1.png';
import image2 from '../karzoun/2.png';
import image3 from '../karzoun/3.png';
import image4 from '../karzoun/4.png';
import image5 from '../karzoun/5.png';
import image6 from '../karzoun/6.png';
import image7 from '../karzoun/7.png';


export const KarzounApp = {
  id:3,
  type:'mobile',
  thumbnails: [thumbnail_karzoun],
  screens: [image0, image1, image2, image3, image4, image5, image6,image7],
  title: 'Karzoun – Your All-in-One Mobile App for Smart Business and Social Media Management',
  intro:
    "From customer engagement to employee task tracking, Karzoun is a unified mobile platform built to streamline your business operations. Whether you're managing marketing campaigns, organizing customer data, or automating repetitive workflows, Karzoun centralizes it all into one intelligent, easy-to-use app. Let’s explore how Karzoun transforms the way teams manage their digital presence and daily business functions.",
  features: [
    {
      title: "Unified Dashboard for Total Oversight",
      description:
        "Karzoun brings together your social media, marketing, sales, and support functions into one centralized dashboard — giving you full control and visibility in real time."
    },
    {
      title: "Customer Journey Tracking",
      description:
        "Understand and monitor the complete customer lifecycle — from first interaction to conversion and retention — with integrated data and behavioral insights."
    },
    {
      title: "Smart Marketing & Retargeting Tools",
      description:
        "Launch, schedule, and manage campaigns across channels. Use built-in analytics to retarget users, optimize conversions, and increase engagement."
    },
    {
      title: "Task and Workflow Automation",
      description:
        "Create automated workflows for repetitive tasks, assign duties to team members, and track task completion with intuitive project management tools."
    },
    {
      title: "Real-Time Communication & Support",
      description:
        "Engage with customers instantly through integrated chat, ticketing systems, and automated replies to ensure seamless support and fast resolution."
    },
    {
      title: "Customer Database Management",
      description:
        "Organize, categorize, and search customer data effortlessly. Use tags, filters, and custom fields to segment users for better targeting and service."
    },
    {
      title: "Push Notifications & Alerts",
      description:
        "Keep your team and your customers informed with smart alerts for tasks, updates, deadlines, and promotional campaigns."
    }
  ],
  conclusion:
    "Karzoun is more than just a business app — it’s your digital operations hub. From marketing and sales to automation and customer support, everything you need lives in one place. Whether you're a startup or an enterprise, Karzoun empowers your team to work smarter, faster, and more efficiently. Get started today and redefine your business flow!"
};
